<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <router-link to="/Pay/Create">
          <el-button type="primary" size="mini">新建款项支付</el-button>
        </router-link>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="form2.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="list-title">
      <el-row>
        <el-col class="item-select" :span="5">
          <label>支付类别：</label>
          <el-select size="mini" v-model="form2.payTypeId" placeholder="请选择">
            <el-option v-for="item in payTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <!-- <el-col class="item-select l" v-if="form.type!=0" :span="5">
          <label>当前状态：</label>
          <el-select v-model="filterStatus" size="mini" placeholder="请选择">
            <el-option v-for="item in statusArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </!-->
        <div class="item-input" style="float:left;">
          <label>负责人：</label>
          <el-input style="width:160px;" v-model="form2.creator" size="mini" placeholder="项目负责人姓名"></el-input>
        </div>
        <div class="item-input" style="float:left;">
          <label>项目名称：</label>
          <el-input style="width:300px;" v-model="form2.name" size="mini" placeholder="你可以搜索项目名"></el-input>
        </div>
      </el-row>
    </div>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="form2.type">
        <el-radio-button label="0">进行中</el-radio-button>
        <el-radio-button label="1">已审批通过</el-radio-button>
        <el-radio-button label="2">已取消/拒绝</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="支付内容">
        <template slot-scope="scope">
          <span class="title-z">{{ scope.row.isAlone ? '独立' : '工程/合同' }}</span>
          <a href="javascript:;" class="table-link" @click="projectDetail(scope.row)">
            {{
            getPayName(scope.row) }}
          </a>
        </template>
      </el-table-column>

      <el-table-column prop="payType" label="支付类型" width="80px"></el-table-column>
      <el-table-column prop="htjk" label="(合同/支付)价款(元)" width="80px"></el-table-column>
      <el-table-column label="本期支付(元)" width="110px">
        <template slot-scope="scope">
          <span v-if="scope.row.bqzf">{{ scope.row.bqzf + '('+scope.row.zfzshzj+'%)' }}</span>
          <span v-else>/</span>
        </template>
      </el-table-column>

      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData="scope.row.flow.creator"></user-info>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button>

          <!-- <el-tooltip class="item" effect="dark" content="编辑款项类别" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="editPayTypeBtnClick(scope.row)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除款项类别" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="deletePayType(scope.row)"></i>
          </el-tooltip>-->

          <!-- 填表人修改权限 -->
          <span v-if="scope.row.isAlone && scope.row.flow.creator.id==userData.id">
            <span v-if="scope.row.flow.status!='审批通过'">
              <el-tooltip class="item" effect="dark" content="修改款项支付审批" placement="bottom">
                <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"
                  @click="getRouterLink(scope.row.flow.applyId, scope.row.projectId)"></i>
              </el-tooltip>
            </span>
            <cancel-flow :successPlus="true" :flow="scope.row.flow" @getLists="getLists"></cancel-flow>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>-->

    <!-- {{pageTotal+","+form2.pageSize}} -->
    <el-pagination v-if="pageTotal>form2.pageSize" class="list-pagination" background :page-size="form2.pageSize"
      :pager-count="9" :current-page="form2.page+1" layout="pager" :total="pageTotal"
      @current-change="handleCurrentChange"></el-pagination>

    <project-info></project-info>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import CancelFlow from "@/components/CancelFlow";
  import UserInfo from "@/components/UserInfo";
  import ApprovalStatus from "@/components/ApprovalStatus";
  import projectInfo from "@/page/user/projectInfo";
  import Role from "@/Mixins/role";
  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
      CancelFlow
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData
      }),
      form2Watch: function(){
        let watchArr = []
        // console.log(this.form2)
        watchArr.push(this.form2.type)
        watchArr.push(this.form2.payTypeId)
        watchArr.push(this.form2.name)
        watchArr.push(this.form2.depId)
        watchArr.push(this.form2.creator)
        return watchArr.join(",")
        // return ""
      }
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: "",

        // 后端分页
        form2: {
          page: 0,
          pageSize: 20,
          type: 0,
          payTypeId: "",
          name: "",
          depId: "",
          creator: ""
        },

        // 列表
        loading: true,
        pageTotal: 0,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        // filterStatus: "",
        // statusArr: ["全部", "进行中", "审批通过", "已拒绝", "已取消"],
        // filterKey: "",
        // filterType: 0,

        // 款项支付所属类型
        payTypeList: [],
        // listType: 0,

        // 取消审批相关
        cancleStatus: false,
        form: {
          flowId: "",
          remark: ""
        }
      };
    },
    created() {
      this.getPayType();
    },
    mounted() {
      // console.log(this.organization.length > 0)

      this.organizationListData.push({
        id: 0,
        name: "集团所有公司",
        depId: 0
      });
      let _or =
        this.organization.length > 0 ? this.organization[0].childDepts : [];
      this.organizationListData = this.organizationListData.concat(_or);

      this.form2.depId = this.depId = this.userData.secDepIds.split(",")[0] / 1;

      if (this.depId == "7" || this.backRole("SYSTEM_1")) {
        this.noSelectOrganization = false;
        this.form2.depId = this.depId = 0;
      }
    },
    methods: {
      // 编辑的链接生成
      getRouterLink(applyId, projectId) {
        this.$router.push({
          path: "/Pay/Create",
          query: {
            applyId: applyId,
            projectId: projectId
          }
        });
      },

      // 取消审批提交
      cancelFlowSubmit() {
        ajax.post("/gc/project/flow/cancel", this.form, res => {
          this.$message.success("取消审批成功");
          this.$store.commit("set_projectReload", true);
          this.cancleStatus = false;
          this.getLists();
        });
      },
      // 取消审批弹窗
      cancelFlow(flow) {
        this.form.flowId = flow.id;
        this.cancleStatus = true;
      },

      // 显示审批详情
      projectDetail(row) {
        console.log(row);
        let _projectTable = {
          status: true,
          applyId: row.id,
          tableType: row.flow.flowsource
        };
        this.$store.commit("set_projectTable", _projectTable);
      },
      // 获取支付内容
      getPayName(row) {
        let _payType = this.getPayTypeName(row.payType);
        if (row.projectName) {
          return row.projectName + (_payType ? " - " + _payType : "");
        } else if (row.htmc) {
          return row.htmc + (_payType ? " - " + _payType : "");
        } else {
          return row.name;
        }
      },
      // 获取支付类型名称
      getPayTypeName(typeId) {
        console.log(typeId);
        for (var i = 0; i < this.payTypeList.length; i++) {
          if (this.payTypeList[i].id == typeId) {
            return this.payTypeList[i].name;
          }
        }
        // return this.payTypeList
      },
      // 获取款项支付类型
      getPayType() {
        this.payTypeList = [{
          name: "全部",
          num: 0,
          id: 0
        }];
        ajax.get("/pay/type/list", "", res => {
          this.payTypeList = this.payTypeList.concat(res.vo.array);
        });
      },
      // 当前页
      handleCurrentChange(val) {
        this.form2.page = val - 1
        this.getLists()
        // this.currentPage = val;
        // this.getPaginationData();
      },
      // 搜索筛选数据
      // getFilterData() {
      //   // console.log(this.filterName)
      //   if (this.filterType != 0 || this.filterKey) {
      //     // 筛选出所有符合的数据
      //     this.filterData = [];
      //     for (let i = 0; i < this.listData.length; i++) {
      //       let _project = this.listData[i];

      //       // 筛选支付类别
      //       let _filterType = true;
      //       if (
      //         this.filterType != 0 &&
      //         (!_project.payTypeId || this.filterType != _project.payTypeId)
      //       ) {
      //         _filterType = false;
      //       }

      //       // // 筛选当前状态
      //       // let _filterStatus = false
      //       // if (this.filterStatus == '全部') {
      //       //   _filterStatus = true
      //       // }
      //       // else if(_project.flow.status.toLowerCase().indexOf(this.filterStatus.toLowerCase()) != -1) {
      //       //   _filterStatus = true
      //       // }

      //       // 筛选搜索结果
      //       if (_filterType) {
      //         if (
      //           (_project.projectName &&
      //             _project.projectName
      //               .toLowerCase()
      //               .indexOf(this.filterKey.toLowerCase()) != -1) ||
      //           (_project.htmc &&
      //             _project.htmc
      //               .toLowerCase()
      //               .indexOf(this.filterKey.toLowerCase()) != -1) ||
      //           (_project.name &&
      //             _project.name
      //               .toLowerCase()
      //               .indexOf(this.filterKey.toLowerCase()) != -1) ||
      //           _project.flow.creator.name
      //             .toLowerCase()
      //             .indexOf(this.filterKey.toLowerCase()) != -1
      //         ) {
      //           this.filterData.push(_project);
      //         }
      //       }
      //     }
      //   } else {
      //     this.filterData = this.listData;
      //   }
      //   this.currentPage = 1;
      //   this.getPaginationData();
      // },
      // 分页筛选数据
      getPaginationData() {
        // if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
        //   this.currentPage = Math.ceil(this.filterData.length / this.pageSize);
        // }
        // if (this.currentPage == 0) {
        //   this.currentPage = 1;
        // }
        // // 分页筛选
        // this.paginationData = this.filterData.slice(
        //   this.pageSize * (this.currentPage - 1),
        //   this.pageSize * this.currentPage
        // );

        // if (this.isMobile && this.isConcat) {
        //   this.paginationData = this.paginationData.concat(this.filterData)
        // } else {
        this.paginationData = this.filterData;
        // }
      },
      // 获取列表
      getLists() {
        this.loading = true;
        ajax.get(
          "/pay/list", {
            page: this.form2.page,
            pageSize: this.form2.pageSize,
            type: this.form2.type,
            payTypeId: this.form2.payTypeId == 0 ? "" : this.form2.payTypeId,
            name: this.form2.name,
            depId: this.form2.depId == 0 ? "" : this.form2.depId,
            creator: this.form2.creator
          },
          res => {
            this.loading = false;
            let _resArr = [];

            switch (this.listType) {
              case "1":
                _resArr = res.vo.list.filter(item => {
                  return item.flow.status == "审批通过";
                });
                break;
              case "2":
                _resArr = res.vo.list.filter(item => {
                  return item.flow.status != "审批通过";
                });
                break;
              default:
                _resArr = res.vo.list;
                break;
            }

            this.filterData = this.listData = _resArr
            this.pageTotal = res.vo.size
            this.getPaginationData()
          }
        );
      }
    },
    watch: {
      form2Watch () {
        console.log(this.form2Watch)
        this.form2.page = 0
        this.getLists()
      },
    }
  };

</script>



// WEBPACK FOOTER //
// src/page/pay/list.vue